module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAFo9M/3AAAABGdBTUEAALGPC/xhBQAAAJ5JREFUOBHNkt0NgCAMhNW4gu4/hGzgCDqGMyhf4EwNP5H4YhM8aq/XE+y6EA44/DpD7p/9I7PJEDl7xBsm7WDcCS8TMTE3bSzSipGHBIRigaICyaysCEJIq5IcJsXRsKojqh6qxeJJxdEOfHUOTSTzYeUtipjnbpKzKbcFv2oEEXoVdmJTI+r6n7HbuhwCn6YjoPif0OytcYWLLObwAvE4OPTf1qgaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/buttons/arrow-left.png
// module id = 281
// module chunks = 0